import {
  Button,
  Col,
  Form,
  Input,
  message,
  Modal,
  Radio,
  Row,
  Space,
} from "antd";
import { apiRequest } from "../../../api";
import apiPaths from "../../../api/paths";

function AddUserModal({
  open = false,
  onSave = () => {},
  onCancel = () => {},
}) {
  const handleOnSave = async (values) => {
    let splitName = values.full_name.split(" ");
    values.first_name = splitName[0];
    values.last_name = splitName[1] || null;
    delete values.full_name;
    const res = await apiRequest({
      path: apiPaths.users + "/admin",
      method: "POST",
      data: values,
    });
    if (res.error) {
      message.error(res.error_description);
      return;
    }
    onSave(res);
  };

  return (
    <Modal
      title={"Add User"}
      centered
      width={900}
      visible={open}
      onCancel={onCancel}
      footer={null}
    >
      <Form layout="vertical" onFinish={handleOnSave}>
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item
              label="Phone Number"
              name="contact_number"
              rules={[
                {
                  required: true,
                  message: "Please input Phone Number",
                },
              ]}
            >
              <Input maxLength={10} placeholder="Phone Number" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Full Name"
              name="full_name"
              rules={[
                {
                  required: true,
                  message: "Please input Full name",
                },
              ]}
            >
              <Input placeholder="Full Name" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item
              label="Is Admin"
              name="is_admin"
              rules={[
                {
                  required: true,
                  message: "Please select Is Admin",
                },
              ]}
            >
              <Radio.Group>
                <Radio value={true}>Yes</Radio>
                <Radio value={false}>No</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Is Supervisor"
              name="is_supervisor"
              rules={[
                {
                  required: true,
                  message: "Please select Is Supervisor",
                },
              ]}
            >
              <Radio.Group>
                <Radio value={true}>Yes</Radio>
                <Radio value={false}>No</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
        </Row>
        <Form.Item>
          <Space style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button onClick={onCancel}>Cancel</Button>
            <Button type="primary" htmlType="submit">
              {"Save"}
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default AddUserModal;
